import { Button, ButtonMode, Icon, ICONS, Tooltip } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';

import styles from './DisplayTypeSelection.module.scss';

const cx = classNames.bind(styles);

export const DisplayTypeKey = 'displayType';

export enum DisplayType {
  Cozy = 'COZY',
  Expanded = 'EXPANDED',
}

interface DisplayTypeSelectionProps {
  selected: DisplayType;
  onSelect: (selected: DisplayType) => void;
}

const DisplayTypeSelection = ({ selected, onSelect }: DisplayTypeSelectionProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      <Tooltip
        trigger={
          <Button
            onClick={() => {
              onSelect(DisplayType.Cozy);
            }}
            className={cx('action-btn', { 'is-selected': selected === DisplayType.Cozy })}
            dataTestId="cozy-view-button"
            ariaLabel="Cozy View"
            mode={ButtonMode.TERTIARY}
            hasEqualSidesPadding
          >
            <Icon name={ICONS.CozyView} width={16} height={16} />
          </Button>
        }
        content="Cozy View"
      />
      <Tooltip
        trigger={
          <Button
            onClick={() => {
              onSelect(DisplayType.Expanded);
            }}
            className={cx('action-btn', { 'is-selected': selected === DisplayType.Expanded })}
            dataTestId="expanded-view-button"
            ariaLabel="Expanded View"
            mode={ButtonMode.TERTIARY}
            hasEqualSidesPadding
          >
            <Icon name={ICONS.ExpandedView} width={16} height={16} />
          </Button>
        }
        content="Expanded View"
      />
    </div>
  );
};

export default DisplayTypeSelection;
